export default "/images/paychex_logo.png?78e5e78939c79e3cad9b4d255e2902d2";